import { TIERS } from "./constants";

export function getBundlePrice(id, price, quantity) {
  const multiplierDiscounts = TIERS[id].bundleDiscounts;
  return (
    price * quantity -
    price * quantity * multiplierDiscounts[quantity.toString()]
  );
}

export function getBundleDiscount(id, quantity) {
  const multiplierDiscounts = TIERS[id].bundleDiscounts;
  return multiplierDiscounts[quantity.toString()];
}

export function getBundleDiscountPercent(id, quantity) {
  return getBundleDiscount(id, quantity) * 100;
}
